
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/city-census/CensusData",
      function () {
        return require("private-next-pages/city-census/CensusData.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/city-census/CensusData"])
      });
    }
  